// extracted by mini-css-extract-plugin
export default {"itemBox":"wineScroller_itemBox__AYUnh","itemIsActive":"wineScroller_itemIsActive__dxBEg","wineBox":"wineScroller_wineBox__Arhsb","textOverflow":"wineScroller_textOverflow__60dq7"};